import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';


@Injectable()

export class InsuredService {
	private url: string = Global.url_seguros;
	private _http = inject(HttpClient)
	private _userService: UserService = inject(UserService)
	private entity: any = this._userService.sharingEntity();

	create(insured: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.post(this.url + 'insureds', insured, {headers: headers})
	}
	getInsuredByRut(rut: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/rut/' + rut  , {headers: headers})
	}

	getInsuredById(id: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/id/' + id  , {headers: headers})
	}

	getInsuredByName(name: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/name/' + name, {headers: headers})
	}
	
	getGenders(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/genders', {headers: headers})
	}

	update(insured: any): Observable<any> {
		let params = insured
		let headers = new HttpHeaders().set('Content-Type','application/json')
		return this._http.patch(this.url + 'insureds' , params, {headers: headers})
	}

	getInsuredTypes(): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/relationship', {headers: headers})
	}

	getFamily(insured: any, policy: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/family/' + insured + '/' + policy, {headers: headers})
	}


	getBankAccount(insured: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/bank-accounts/' + insured, {headers: headers})
	}

	saveBankAccount(form: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.post(this.url + 'insureds/bank-accounts', form, {headers: headers})
	}


	getPositions(insured: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'insureds/positions/' + insured, {headers: headers})
	}
}
